import { render, staticRenderFns } from "./DuplicateModal.vue?vue&type=template&id=7ae2d0d0&scoped=true"
import script from "./DuplicateModal.vue?vue&type=script&lang=js"
export * from "./DuplicateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ae2d0d0",
  null
  
)

export default component.exports